import { Action } from './action';

export class Logout extends Action {
}
